module.exports = __webpack_public_path__ + "static/media/Calibre-Light.183de736.woff2";